import React from 'react';
import { colors, type, space, radius } from '../tokens';
import Avatar from './Avatar';

const Group = ({ title, items, onSelect, selectedId, emptyText }) => (
  <div style={{
    flex: 1,
    minWidth: 240,
  }}>
    <div style={{
      ...type.label,
      color: colors.textTertiary,
      paddingBottom: space[2],
      borderBottom: `1px dashed ${colors.border}`,
      marginBottom: space[3],
    }}>
      {title} <span style={{ color: colors.textTertiary }}>({items.length})</span>
    </div>
    {items.length === 0 && (
      <div style={{ ...type.small, color: colors.textTertiary, fontStyle: 'italic' }}>
        {emptyText || 'None.'}
      </div>
    )}
    <div style={{ display: 'flex', flexDirection: 'column', gap: space[2] }}>
      {items.map(it => (
        <button
          key={it.id}
          onClick={onSelect ? () => onSelect(it.id) : undefined}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: space[3],
            padding: space[2],
            background: selectedId === it.id ? colors.brandMuted : colors.surface,
            border: `1px solid ${selectedId === it.id ? colors.brand : colors.border}`,
            borderRadius: radius.sm,
            textAlign: 'left',
            cursor: onSelect ? 'pointer' : 'default',
            fontFamily: 'inherit',
            width: '100%',
          }}
        >
          <Avatar initials={it.initials} color={it.avatarColor} size="sm" />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ ...type.small, fontWeight: 700, color: colors.textPrimary, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {it.label}
            </div>
            <div style={{ ...type.micro, color: colors.textTertiary }}>
              {it.subtitle}
              {it.former && ' · former'}
            </div>
          </div>
          {it.statValue && (
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={{ ...type.micro, color: colors.textTertiary }}>{it.statLabel}</div>
              <div style={{ ...type.small, fontWeight: 700, color: colors.timeline.gift }}>{it.statValue}</div>
            </div>
          )}
        </button>
      ))}
    </div>
  </div>
);

const RelationshipCardList = ({ groups = {}, onSelect, selectedId }) => (
  <div style={{ display: 'flex', gap: space[4], flexWrap: 'wrap' }}>
    <Group title="Household" items={groups.household || []} onSelect={onSelect} selectedId={selectedId} />
    <Group title="Affiliations" items={groups.affiliations || []} onSelect={onSelect} selectedId={selectedId} />
    <Group title="Relationships" items={groups.relationships || []} onSelect={onSelect} selectedId={selectedId} />
    {groups.softCredits && <Group title="Soft-credit network" items={groups.softCredits} onSelect={onSelect} selectedId={selectedId} />}
  </div>
);

export default RelationshipCardList;
